module.exports = __webpack_public_path__ + "img/icon_L1.471370f0.png";